import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box } from "@mui/system";
import { Grid, Typography } from "@mui/material";

const renderRelianceIPAOptionComponent = (props, option) => {
  return (
    <li {...props}>
      <Grid container alignItems="center">
        <Grid item sx={{ display: "flex", width: 44 }}>
          <LocationOnIcon sx={{ color: "secondary" }} />
        </Grid>
        <Grid
          item
          sx={{
            width: "calc(100% - 44px)",
            wordWrap: "break-word",
          }}
        >
          <Box component="span">{`${option.area_name}`}</Box>
          <Typography variant="body2" color="text.secondary">
            {`${option.district_name}, ${option.state_name}`}
          </Typography>
        </Grid>
      </Grid>
    </li>
  );
};

export default renderRelianceIPAOptionComponent;
